<div class="d-flex justify-content-end" *ngIf="formIsRendered">
  
  <ng-container *ngIf="formMetaData.submit">
    <button
    *ngIf="context.readonly"
    (click)="togglePresentationMode()"
    mat-flat-button
    color="primary"
    type="button"
    class="d-flex align-items-center m-r-2"
  >
    <i-tabler
      [name]="context.presentationMode ? 'eye-off' : 'eye'"
      class="icon-18 m-r-2"
    ></i-tabler>
    <span>{{ context.presentationMode ? "Standard" : "Presentation" | translate}}</span>
  </button>

  <button
    *ngIf="!context.readonly && formChanged"
    [disabled]="!formChanged"
    (click)="save()"
    mat-flat-button
    color="primary"
    type="button"
    class="d-flex align-items-center m-r-2"
  >
    <i-tabler name="edit" class="icon-18 m-r-2"></i-tabler>
    <span>{{"Save" | translate }}</span>
  </button>

  <button
    *ngIf="context.readonly && !context.presentationMode && authService.isDoctor()"
    (click)="enableEditMode()"
    mat-flat-button
    color="primary"
    type="button"
    class="d-flex align-items-center"
  >
    <i-tabler name="edit" class="icon-18 m-r-2"></i-tabler>
    <span>{{'MODIFY' | translate}}</span>
  </button>
  </ng-container>
  
</div>

<div class="row">
  <div class="col">
    <form-renderer
      *ngIf="showFormRenderer"
      #fr
      [formMetadata]="formMetaData"
      [resourceUrl]="betterResourceUrl"
      [credentials]="credentials"
      [formEnvironment]="formEnvironment"
      [context]="context"
      [compositionId]="compositionId"
      (onFormRendered)="formRendered($event)"
      (onValueChange)="valueChange($event)"
    >
    </form-renderer>
  </div>
</div>

<div class="d-grid gap-2 mt-2" *ngIf="debugMode">
  <mat-accordion>
    <mat-expansion-panel class="cardWithShadow mb-2" hideToggle>
      <mat-expansion-panel-header color="warn">
        <mat-panel-title class="mat-warn"> Development Mode </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row">
        <div class="col">
          <p>{{ formMetaData | json }}</p>
          <p>{{ compositionId | json }}</p>
          <p>{{ formEnvironment | json }}</p>
          <p>{{ context | json }}</p>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
